export class AutomatModel {
    _id?: string;
    name: string;
    description: string;
    image: string;
    capacity: number;
    productCount: number;
    column: number;
    indexKey: number;
    isHot: boolean;
    row: number;
    status: number;
    automatBrand: string;
    createdAt: string;
    updatedAt: string;
    vendingCommunicationProtocol?: number;
    pulseTime?: number;
    pulseTimeSensitive?: boolean;
    screenTimeout?: number;
    productGivenTimeout?: number;
    spiralNumberList?: any[];
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/models/automatModel.ts